import React from 'react';
import PropTypes from 'prop-types';

/**
 * Open Graph 메타데이터 컴포넌트
 * 셀러 컬렉션 페이지의 소셜 미디어 공유를 위한 메타데이터를 제공합니다.
 */
export default function SellerCollectionOpenGraph({ collection, title, url }) {
  const collectionUrl = url || window.location.href;
  
  return (
    <>
      <meta property="fb:app_id" content="330702484245822" />
      <meta property="og:site_name" content="FruitsFamily" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={(collection && collection.description) || '후루츠패밀리의 다양한 셀러 컬렉션을 만나보세요. 인기 셀러들의 상품을 한눈에 확인할 수 있습니다.'} />
      <meta property="og:url" content={collectionUrl} />
      {collection && collection.resizedBigImage && (
        <meta property="og:image" content={collection.resizedBigImage} />
      )}
    </>
  );
}

SellerCollectionOpenGraph.propTypes = {
  collection: PropTypes.shape({
    title: PropTypes.string,
    sub_title: PropTypes.string,
    description: PropTypes.string,
    resizedBigImage: PropTypes.string
  }),
  title: PropTypes.string,
  url: PropTypes.string
};

SellerCollectionOpenGraph.defaultProps = {
  title: '후루츠패밀리 셀러 컬렉션'
};
